import { useState, useEffect, useMemo,useRef } from "react";
import DownIcon from "./down.js";
import { useSelector, useDispatch } from "react-redux";
import RadarChart from "./radarChart";
import HeatmapComponent from "./heatMap";
import { useNavigate } from "react-router-dom";
import { getActiveSurveyProgress } from "../../../services/surveyJobInitialize.js";
import { getReportsFromAPI } from "../../../services/reportService";
import { updateTabPath, updateTabStates } from "../../../store/actions";
import { Auth } from "aws-amplify";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export function processSurveyAnswers(surveyAnswers) {

  const questionMap = {};
  const userPageScores = {};
  const userSectionScores = {};
  const userQuestionScores = {};
 
  // Kullanıcı bazlı skorları hesapla
  surveyAnswers.forEach(({ user_id, answers }) => {
    const pageScores = {};
    const sectionScores = {};
    const questionScores = {};

    answers.forEach(({ page, score, type, section, question }) => {

      // Section bazlı puanları topla
      if (section) {
        sectionScores[section] = sectionScores[section] || [];
        sectionScores[section].push(score);
      }

      // Page bazlı puanları section altında gruplandırarak topla
      if (section && page) {
        pageScores[section] = pageScores[section] || {};
        pageScores[section][page] = pageScores[section][page] || [];
        pageScores[section][page].push(score);
      }

      // Question bazlı puanları section altında gruplandırarak topla
      if (page && question) {
        questionScores[page] = questionScores[page] || {};
        questionScores[page][question] = questionScores[page][question] || [];
        questionScores[page][question].push(score);
      }
    });

    userPageScores[user_id] = pageScores;
    userSectionScores[user_id] = sectionScores;
    userQuestionScores[user_id] = questionScores;

  });
  surveyAnswers.forEach(({ user_id, answers }) => {
    answers.forEach(
      
      ({ question_id, section, question, answer, options, type, page, rateCount }) => {
        if (type === "comment" || type === "tagbox" || type === "checkbox" || type === "ranking" || type === "boolean" || type === "text") return;

        if (!questionMap[question_id]) {
          questionMap[question_id] = {
            question_id,
            section,
            question,
            page,
            options:type === "rating" && rateCount
              ? Array.from({ length: rateCount }, (_, i) => ({
                  opt: (i + 1).toString(), // 1'den ratecount'a kadar numaralar
                  scores: { section: {}, page: {}, question: {} },
                }))
              : options?.map((option) => ({
                  opt: option,
                  scores: { section: {}, page: {}, question: {} },
                })),
        };
        }
   
        const questionData = questionMap[question_id];
        const optionIndex = questionData.options?.findIndex(
          (opt) => opt.opt == (answer.Current ? answer.Current.toString() : answer.toString())

        );
        if (optionIndex !== -1) {
          const matchingUsers = surveyAnswers.filter(({ answers }) =>
            answers.some(
              (a) => a.question_id === question_id && a.answer === answer.Current?answer.Current.toString():answer.toString()
            )
          );

          matchingUsers.forEach(({ user_id: matchedUserId }) => {
            // Section bazlı oranları hesapla
            if (userSectionScores[matchedUserId]) {
              Object.entries(userSectionScores[matchedUserId]).forEach(
                ([userSection, scores]) => {
                  questionData.options[optionIndex].scores.section[
                    userSection
                  ] = [
                      ...(questionData.options[optionIndex].scores.section[
                        userSection
                      ] || []),
                      ...scores,
                    ];
                }
              );
            }

            // Page bazlı oranları section içinde hesapla
            if (userPageScores[matchedUserId]) {
              Object.entries(userPageScores[matchedUserId]).forEach(
                ([userSection, pages]) => {
                  Object.entries(pages).forEach(([userPage, scores]) => {
                    if (
                      !questionData.options[optionIndex].scores.page[userSection]
                    ) {
                      questionData.options[optionIndex].scores.page[userSection] = {};
                    }
                    questionData.options[optionIndex].scores.page[userSection][userPage] = [
                        ...(questionData.options[optionIndex].scores.page[userSection][userPage] || []),
                        ...scores,
                      ];
                  });
                }
              );
            }

            // Question bazlı oranları section içinde hesapla
            if (userQuestionScores[matchedUserId]) {
              Object.entries(userQuestionScores[matchedUserId]).forEach(
                ([userSection, questions]) => {
                  Object.entries(questions).forEach(
                    ([userQuestion, scores]) => {
                      if (
                        !questionData.options[optionIndex].scores.question[
                        userSection
                        ]
                      ) {
                        questionData.options[optionIndex].scores.question[
                          userSection
                        ] = {};
                      }
                      questionData.options[optionIndex].scores.question[
                        userSection
                      ][userQuestion] = [
                          ...(questionData.options[optionIndex].scores.question[
                            userSection
                          ][userQuestion] || []),
                          ...scores,
                        ];
                    }
                  );
                }
              );
            }
          });
        }
      }
    );
  });
  // Ortalama skorları hesapla ve sonucu döndür
  return Object.values(questionMap).map(
    ({ question_id, section, question, page, options }) => ({
      question_id,
      section,
      question,
      page,
      options: options.map(({ opt, scores }) => {
        const averagedScores = { section: {}, page: {}, question: {} };

        // Section bazlı ortalama hesapla
        Object.entries(scores.section).forEach(([sec, scoreList]) => {
          averagedScores.section[sec] = scoreList.length
            ? scoreList.reduce((a, b) => a + b, 0) / scoreList.length
            : 0;
        });

        // Page bazlı ortalama section içinde hesapla
        Object.entries(scores.page).forEach(([sec, pages]) => {
          averagedScores.page[sec] = {};
          Object.entries(pages).forEach(([pg, scoreList]) => {
            averagedScores.page[sec][pg] = scoreList.length
              ? scoreList.reduce((a, b) => a + b, 0) / scoreList.length
              : 0;
          });
        });

        // Question bazlı ortalama section içinde hesapla
        Object.entries(scores.question).forEach(([sec, questions]) => {
          averagedScores.question[sec] = {};
          Object.entries(questions).forEach(([qst, scoreList]) => {
            averagedScores.question[sec][qst] = scoreList.length
              ? scoreList.reduce((a, b) => a + b, 0) / scoreList.length
              : 0;
          });
        });

        return { opt, scores: averagedScores };
      }),
    })
  );
}
export default function Insight() {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const themeMode = useSelector((state) => state.themeMode);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const currentSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurvey;
  const rawCurrentSurveyInsightData = useMemo(() => {
    const activeTab = topMenuTabs.tabs.find(
      (tab) => tab.id === topMenuTabs.activeTab
    );
    return activeTab ? activeTab.states.currentSurveyInsightData : null;
  }, [topMenuTabs.tabs, topMenuTabs.activeTab]);
  const currentSurveyInsightData = useMemo(() => {
    if (!rawCurrentSurveyInsightData) return [];
    return Array.isArray(rawCurrentSurveyInsightData)
      ? rawCurrentSurveyInsightData
      : [rawCurrentSurveyInsightData];
  }, [rawCurrentSurveyInsightData]);
   const surveyCardRef = useRef(null);

  const DEFAULT_SCORING = {
    maxScore: 5,
    stages: [
      { id: "s1", name: "Initial", description: "", from: 1, to: 1.5 },
      { id: "s2", name: "Under Development", description: "", from: 1.5, to: 2.5 },
      { id: "s3", name: "Defined", description: "", from: 2.5, to: 3.5 },
      { id: "s4", name: "Managed", description: "", from: 3.5, to: 4.5 },
      { id: "s5", name: "Measured", description: "", from: 4.5, to: 5 },
    ],
  };

  const scoringConfig = (currentSurvey && currentSurvey.scoring) ? currentSurvey.scoring : DEFAULT_SCORING;
  const scoringMaxScore = scoringConfig.maxScore || 5;
  const scoringCoefficient = scoringMaxScore / 5;

  const getDisplayScore = (internalScore) => internalScore * scoringCoefficient;

  const getActiveStage = (internalScore) => {
    const displayScore = getDisplayScore(internalScore);
    const stageList = scoringConfig.stages || [];
    const found = stageList.find(
      (s) => displayScore >= s.from && displayScore < s.to
    );
    return found || stageList[stageList.length - 1] || { name: "", description: "" };
  };

  const [leftPercentage, setLeftPercentage] = useState(0);
  const [stages, setStages] = useState(
    (scoringConfig.stages || []).map((s) => ({ name: s.name, active: false }))
  );
  const [surveyReportResults, setSurveyReportResults] = useState([]);
  const currentSurveyRunningJob = useMemo(() => {
    const surveyId = currentSurvey?.ID;
    if (!surveyId) return null;
    return (surveyReportResults || []).find(
      (item) =>
        item?.survey_id === surveyId && item?.status?.toLowerCase() === "running"
    );
  }, [surveyReportResults, currentSurvey?.ID]);

  const surveyIsCompleted = currentSurvey?.status?.toLowerCase() === "completed";
  const isReportGenerating =
    currentSurveyRunningJob ||
    (surveyIsCompleted && currentSurveyInsightData[0]?.report_detail?.scores === undefined);
  let [token, setToken] = useState("");
  useEffect(() => {
    if (
      currentSurveyInsightData &&
      currentSurveyInsightData[0]?.report_detail?.scores?.overall
    ) {
      const survey_answers =
        currentSurveyInsightData[0]?.report_detail?.survey_answers;
      if (survey_answers) {
        const processedAnswers = processSurveyAnswers(survey_answers);
        if (JSON.stringify(processedAnswers) !== JSON.stringify(totalAnswers)) {
          setTotalAnswers(processedAnswers);
        }
        // setTotalAnswers(processedAnswers);

      }
      const internalOverall = currentSurveyInsightData[0].report_detail.scores.overall;
      const displayScore = getDisplayScore(internalOverall);
      setLeftPercentage((displayScore / scoringMaxScore) * 100);

      const activeStage = getActiveStage(internalOverall);
      const newStages = (scoringConfig.stages || []).map((s) => ({
        name: s.name,
        active: s.name === activeStage.name,
      }));
      setStages(newStages);
    }
  }, [currentSurveyInsightData]);
  const radarChartData = [
    {
      name: "Series 1",
      data: currentSurveyInsightData[0]?.report_detail?.scores?.sections?.map(
        (x) => x.score
      ),
    },
  ];
  const [totalAnswers, setTotalAnswers] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const prevResultsRef = useRef([]);
  
  async function getToken(providedToken) {
    if (providedToken) {
      setToken(providedToken);
      return;
    }
    const currentSession = await Auth.currentSession();
    setToken(currentSession.idToken.jwtToken);
  }
  const ProgressBar = ({ value }) => {
    const safeValue = Math.min(Math.max(value ?? 0, 0), 100);

    return (
      <div className="w-full mt-2">
        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-2 bg-[#5195D7] transition-all duration-300"
            style={{ width: `${safeValue}%` }}
          />
        </div>
        <div className="text-[0.65rem] text-right mt-1 text-gray-500">
          %{safeValue}
        </div>
      </div>
    );
  };
  async function getSurveyProgress(authToken) {
    if (!authToken) return [];
    try {
      const results = await getActiveSurveyProgress(authToken, "result");
      setSurveyReportResults(results || []);
      return results || [];
    } catch (error) {
      if (error.message === "Request failed with status code 401") {
        checkAuth();
      }
      return [];
    }
  }

  async function refreshInsightData(authToken) {
    const surveyId = currentSurvey?.ID;
    if (!surveyId || !authToken) return;
    try {
      dispatch(updateTabStates(topMenuTabs.activeTab, "currentSurveyInsightData", {}));
      const result = await getReportsFromAPI(authToken, surveyId);
      const normalizedInsightData = Array.isArray(result) ? (result[0] || {}) : (result || {});
      dispatch(
        updateTabStates(
          topMenuTabs.activeTab,
          "currentSurveyInsightData",
          normalizedInsightData
        )
      );
    } catch (error) {
      const msg = error?.message || "";
      if (msg.includes("401")) {
        checkAuth();
      }
    }
  }
  useEffect(()=>{
    const prevResults = prevResultsRef.current;
  
    // running -> completed olan var mı?
    const hasJustCompleted = surveyReportResults.some(newItem => {
      const prevItem = prevResults.find(
        p => p.job_id === newItem.job_id
      );
  
      return (
        prevItem &&
        prevItem.status.toLowerCase() === "running" &&
        newItem.status.toLowerCase() === "completed"
      );
    });
  
    prevResultsRef.current = surveyReportResults;

    // If report job just completed, refetch latest report/insight data
    if (hasJustCompleted) {
      refreshInsightData(token);
    }

  },[surveyReportResults, token, currentSurvey?.ID])

  useEffect(() => {
    if (token.length === 0) return;

    let intervalId = null;
    let isDisposed = false;

    const runPolling = async () => {
      const results = await getSurveyProgress(token);
      if (isDisposed) return;

      const hasRunningJob = (results || []).some(
        (item) => item?.status?.toLowerCase() === "running"
      );

      if (hasRunningJob && !intervalId) {
        intervalId = setInterval(async () => {
          const nextResults = await getSurveyProgress(token);
          if (isDisposed) return;
          const stillRunning = (nextResults || []).some(
            (item) => item?.status?.toLowerCase() === "running"
          );
          if (!stillRunning && intervalId) {
            clearInterval(intervalId);
            intervalId = null;
          }
        }, 5000);
      }
    };

    runPolling();

    return () => {
      isDisposed = true;
      if (intervalId) clearInterval(intervalId);
    };
  }, [token]);
    async function checkAuth() {
      // window.location.reload();
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        await cognitoUser.refreshSession(
          currentSession.refreshToken,
          (err, session) => {
            const { idToken, refreshToken, accessToken } = session;
            getToken(idToken.jwtToken);
          }
        );
      } catch (e) {
        // console.log('Unable to refresh Token', e);
      }
    }
  
    useEffect(() => {
      getToken();
    }, []);
  return (
    <div
      className={`flex flex-col w-full pl-4 ${themeMode === "dark"
        ? "bg-[#1a1a28] text-white"
        : "bg-[#fbfbfc] text-black"
        }`}
    >
      {isReportGenerating && (
        <div
          className={`mr-4 mt-4 mb-2 rounded-md border p-3 ${
            themeMode === "dark"
              ? "border-white-09 bg-[#0f1220] text-white"
              : "border-black-09 bg-white text-[#1a1a28]"
          }`}
        >
          <div className="flex items-center justify-between gap-3">
            <div className="flex flex-col">
              <div className="text-sm font-semibold">Report is being generated</div>
              <div className="text-xs opacity-70">
                Your survey has been completed. Insights will appear automatically when the report is ready.
              </div>
            </div>
            {currentSurveyRunningJob?.progress !== undefined && (
              <div className="min-w-[120px]">
                <div className="text-[0.65rem] text-right opacity-70">
                  %{Math.min(Math.max(currentSurveyRunningJob.progress ?? 0, 0), 100)}
                </div>
              </div>
            )}
          </div>
          {currentSurveyRunningJob?.progress !== undefined && (
            <ProgressBar value={currentSurveyRunningJob.progress} />
          )}
        </div>
      )}
      {currentSurveyInsightData[0]?.report_detail?.scores !== undefined&&(
        <div className="flex justify-start w-full pr-4 flex-col 2xl:flex-row ">
          <div className="xl:w-[100%] 2xl:w-[75%] flex flex-col">
            <div className="flex-col flex lg:flex-col gap-4">
              <div className="items-top lg:text-start flex-1  mt-4 flex flex-row space-x-12 pr-12">
                <div
                  className={`shadow-md rounded-lg pt-2 px-0 pb-0 lg:w-{[400px]} h-[150px]  sm:min-w-[150px] w-2/3  
                          bg-white text-gray-800 cursor-pointer
                            `}
                >
                  <div className="p-4 py-1 rounded-lg space-y-0">
                    <div className="flex justify-between items-center mb-0">
                      <span className="size-5 whitespace-nowrap text-lg font-bold text-[#1a1a28] flex flex-grow">
                        OVERALL SCORE
                      </span>
                    </div>
                    <div className="flex justify-between items-center mb-0 flex-wrap">
                      <p className="text-[30px] sm:text-[64px] font-bold text-[#44a5e4]">
                        {" "}
                        {getDisplayScore(
                          currentSurveyInsightData[0]?.report_detail?.scores?.overall
                        ).toFixed(2)}
                      </p>
                      <span
                        className="size-5 whitespace-nowrap font-bold text-xs sm:text-[20px] text-[#4a4a4a] flex flex-grow justify-end min-w-0 text-ellipsis"
                        title={
                          getActiveStage(
                            currentSurveyInsightData[0]?.report_detail?.scores?.overall
                          ).name
                        }
                      >
                        {(() => {
                          const stageName = getActiveStage(
                            currentSurveyInsightData[0]?.report_detail?.scores?.overall
                          ).name;
                          return stageName.length > 10
                            ? stageName.substring(0, 10) + "..."
                            : stageName;
                        })()}
                      </span>
                    </div>
                    <div className="relative w-full bg-transparent h-[13px]">
                      <div
                        className="bg-custom-gradient h-[13px]"
                        style={{ width: `${leftPercentage}%` }}
                      ></div>
                      <div
                        className="absolute bg-[#596877] top-[0px] h-[13px] z-20"
                        style={{
                          left: `${leftPercentage}%`,
                          width: `${100 - leftPercentage}%`,
                        }}
                      ></div>
                      <div
                        className="absolute top-[-8px] h-[5rem] w-10 transform -translate-x-1/2 z-20"
                        style={{ left: `${leftPercentage}%` }}
                      >
                        <DownIcon className={`w-8 h-8 `} stroke="2" fill="#fff" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`shadow-md rounded-lg pt-2 px-0 pb-0 w-full  lg:w-full min-w-[150px] h-[150px]
                            ${themeMode === "dark"
                      ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                      : "bg-white text-gray-800 cursor-pointer"
                    }
                              
                            `}
                >
                  <div className="p-4 py-1 rounded-lg">
                    <div className="flex justify-between items-center mb-3">
                      <div className="flex items-center">
                        <span
                          className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                            }`}
                        >
                          Stages
                        </span>
                      </div>
                    </div>

                    <div
                      className={` sm:block overflow-x-auto overflow-y-hidden   flex justify-center sm:justify-start   mt-8  h-[50px]  px-0 w-full`}
                    >
                      <div
                        aria-label="Tabs"
                        className={`  flex items-center w-full flex-nowrap flex-shrink-0 min-w-0 gap-[0.25rem] rounded-[0.375rem] flex-1   ${themeMode === "dark"
                          ? "bg-[#a5bdff0d]"
                          : "bg-[#1530720d] "
                          }`}
                      >
                        {stages.map((stage, index) => (
                          <div
                            key={stage.name}
                            className={classNames(
                              stage.active
                                ? themeMode === "dark"
                                  ? "bg-[#19b394] text-[#FFFFFF] flex justify-center items-center flex-nowrap flex-shrink-0  hover:text-[#FFFFFF]"
                                  : "bg-[#A5BDFF26] text-[#5a667e] flex justify-center items-center flex-nowrap flex-shrink-0  hover:text-[#000] "
                                : themeMode === "dark"
                                  ? " bg-[#292d32] flex justify-center items-center flex-nowrap flex-shrink-0 hover:rounded-[0.375rem] text-[#C1C9D6] hover:bg-[#a5bdff10] hover:text-[#FFFFFF]"
                                  : "flex justify-center items-center flex-nowrap flex-shrink-0 hover:rounded-[0.375rem] text-[#5a667e] hover:bg-gray-200 hover-text-[#000]",
                              // (Object.keys(currentSurveyResult).length === 0 && tab.name === "Insight") ? "cursor:auto pointer-events-none opacity-50" : "",
                              "group inline-flex items-center  py-2 pl-2 pr-2 text-xs sm:text-sm font-medium w-auto flex flex-1 h-[50px] "
                            )}
                          >
                            <span>{stage.name}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`w-full mt-4 flex flex-1 flex-row items-top space-x-12 
                ${(currentSurveyInsightData[0]?.report_detail?.scores?.sections?.length) > 2 
                  ? "pr-12"
                  : "pr-4"
                }
                `}>
                <div
                  className={`mt-0 shadow-md rounded-lg px-4 pt-0  sm:min-w-[150px] lg:w-{[400px]}  w-2/3 max-h-[400px]
                          cursor-pointer   ${themeMode === "dark"
                      ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                      : "bg-white text-gray-800 cursor-pointer"
                    }
                    ${(currentSurveyInsightData[0]?.report_detail?.scores?.sections?.length) > 2 
                      ? "w-2/3 mt-8"
                      : "w-full"
                    }
                    `}
                >
                  <div className="flex justify-between items-center mb-3">
                    <span
                      className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold pt-2  ${themeMode === "dark"
                        ? "text-[#FFFFFF]"
                        : "text-gray-800"
                        }`}
                    >
                      Overview
                    </span>
                  </div>
                  <article className=" flex flex-col space-y-8 pt-2  overflow-y-scroll     max-h-[370px] ">
                    <p className="text-md  text-balance ">
                      {
                        currentSurveyInsightData[0]?.report_detail
                          ?.overview_comment
                      }
                    </p>
                  </article>
                </div>
                {currentSurveyInsightData[0]?.report_detail?.scores?.sections?.length > 2 && (
                  <RadarChart
                    className="mt-0 py-0 w-full"
                    series={radarChartData}
                    categories={currentSurveyInsightData[0]?.report_detail?.scores?.sections?.map(
                      (x) => x.name
                    )}
                    themeMode={themeMode}
                  />
                )}
              </div>
            </div>
            <div className="flex flex-col ">
              <div className="flex w-full flex-col md:flex-row sm:space-x-8 pr-4 mt-4">
                <div className="w-full md:w-1/2 text-start  mt-4 flex flex-col">
                  <div
                    className={`shadow-md rounded-lg pt-2 px-0 pb-4 w-full min-w-[150px] h-auto 
                          ${themeMode === "dark"
                        ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                        : "bg-white text-gray-800 cursor-pointer"
                      }
                            
                          `}
                  >
                    <div className="p-4 py-1 rounded-lg space-y-8">
                      <div className="flex justify-between items-center mb-3">
                        <span
                          className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold  ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                            }`}
                        >
                          Strengths
                        </span>
                      </div>
                      <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                        <div className="flex justify-between space-x-16 items-center px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              1
                            </span>
                            <p
                              className={`text-md  font ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData[0]?.report_detail
                                  ?.strengths[0]
                              }
                            </p>
                          </div>
                        </div>
                        <div className="flex  space-x-16 items-center justify-between pt-2 px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              2
                            </span>
                            <p
                              className={`text-md  font- ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData[0]?.report_detail
                                  ?.strengths[1]
                              }
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-between space-x-16 items-center pt-2 px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              3
                            </span>
                            <p
                              className={`text-md  font ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData[0]?.report_detail
                                  ?.strengths[2]
                              }
                            </p>
                          </div>
                          {/* <span
                            className={`text-md  font-bold ${
                              themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                            }`}
                          >
                            4.2
                          </span> */}
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full justify-end pr-4 pt-4">
                      <button
                        className={`  w-16 h-[25px] text-[14px] ${themeMode === "dark"
                          ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                          : "border-[#1725471a] bg-[#BCBCBC] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
                          }`}
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                          dispatch(updateTabPath(topMenuTabs.activeTab, 'Strengths & Weaknesses', `/surveys/${currentSurvey.ID}/insight-strengths-weaknesses`));
                          navigate("/surveys/" + currentSurvey.ID + "/insight-strengths-weaknesses");
                        }}
                      >
                        DETAIL
                      </button>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/2 text-start  mt-4 flex flex-col">
                  <div
                    className={`shadow-md rounded-lg pt-2 px-0 pb-4 w-full min-w-[150px] h-auto 
                          ${themeMode === "dark"
                        ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                        : "bg-white text-gray-800 cursor-pointer"
                      }
                            
                          `}
                  >
                    <div className="p-4 py-1 rounded-lg space-y-8">
                      <div className="flex justify-between items-center mb-3">
                        <span
                          className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                            }`}
                        >
                          Weakness
                        </span>
                      </div>
                      <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                        <div className="flex justify-between space-x-16 items-center px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              1
                            </span>
                            <p
                              className={`text-md  ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData[0]?.report_detail
                                  ?.weaknesses[0]
                              }
                            </p>
                          </div>
                        </div>
                        <div className="flex  space-x-16 justify-between items-center pt-2 px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              2
                            </span>
                            <p
                              className={`text-md   ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData[0]?.report_detail
                                  ?.weaknesses[1]
                              }
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-between space-x-16 items-center pt-2 px-2">
                          <div className="flex justify-start space-x-2 items-center">
                            <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                              {" "}
                              3
                            </span>
                            <p
                              className={`text-md   ${themeMode === "dark"
                                ? "text-[#FFFFFF]"
                                : "text-gray-800"
                                }`}
                            >
                              {
                                currentSurveyInsightData[0]?.report_detail
                                  ?.weaknesses[2]
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full justify-end pr-4 pt-4">
                      <button
                        className={`  w-16 h-[25px] text-[14px] ${themeMode === "dark"
                          ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                          : "border-[#1725471a] bg-[#BCBCBC] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
                          }`}
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                          dispatch(updateTabPath(topMenuTabs.activeTab, 'Strengths & Weaknesses', `/surveys/${currentSurvey.ID}/insight-strengths-weaknesses`));
                          navigate("/surveys/" + currentSurvey.ID + "/insight-strengths-weaknesses");
                        }}
                      >
                        DETAIL
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full text-start  mt-4 flex flex-col pr-4 mt-4">
                <div
                  className={`shadow-md rounded-lg pt-2 px-0 pb-4 w-full min-w-[150px] h-auto 
                          ${themeMode === "dark"
                      ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer"
                      : "bg-white text-gray-800 cursor-pointer"
                    }
                            
                          `}
                >
                  <div className="p-4 py-1 rounded-lg space-y-8">
                    <div className="flex justify-between items-center mb-3">
                      <span
                        className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${themeMode === "dark"
                          ? "text-[#FFFFFF]"
                          : "text-gray-800"
                          }`}
                      >
                        Findings
                      </span>
                    </div>
                    <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                      <div className="flex justify-between space-x-16 items-center px-2">
                        <div className="flex justify-start space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            1
                          </span>
                          <p
                            className={`text-md   ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData[0]?.report_detail
                                ?.findings[0]?.finding
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                      <div className="flex  space-x-16 justify-between items-center pt-2 px-2">
                        <div className="flex justify-between space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            2
                          </span>
                          <p
                            className={`text-md   ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData[0]?.report_detail
                                ?.findings[1]?.finding
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                      <div className="flex justify-between space-x-16 items-center pt-2 px-2">
                        <div className="flex justify-start space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            3
                          </span>
                          <p
                            className={`text-md  ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData[0]?.report_detail
                                ?.findings[2]?.finding
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full justify-end pr-4 pt-4">
                    <button
                      className={`  w-16 h-[25px] text-[14px] ${themeMode === "dark"
                        ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                        : "border-[#1725471a] bg-[#BCBCBC] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
                        }`}
                      onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        dispatch(updateTabPath(topMenuTabs.activeTab, 'Findings', `/surveys/${currentSurvey.ID}/insight-findings`));
                        navigate("/surveys/" + currentSurvey.ID + "/insight-findings");
                      }}
                    >
                      DETAIL
                    </button>
                  </div>
                </div>
              </div>
              <div className="w-full text-start  mt-4 flex flex-col pr-4">
                <div
                  className={`shadow-md rounded-lg pt-2 px-0 pb-4 w-full min-w-[150px] h-auto 
                          ${themeMode === "dark"
                      ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer"
                      : "bg-white text-gray-800 cursor-pointer"
                    }
                            
                          `}
                >
                  <div className="p-4 py-1 rounded-lg space-y-8">
                    <div className="flex justify-between items-center mb-3">
                      <span
                        className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${themeMode === "dark"
                          ? "text-[#FFFFFF]"
                          : "text-gray-800"
                          }`}
                      >
                        Recommendations
                      </span>
                    </div>
                    <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                      <div className="flex justify-between space-x-16 items-center px-2">
                        <div className="flex justify-start space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            1
                          </span>
                          <p
                            className={`text-md   ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData[0]?.report_detail
                                ?.recommendations[0]?.recommendation
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                      <div className="flex  space-x-16 justify-between items-center pt-2 px-2">
                        <div className="flex justify-between space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            2
                          </span>
                          <p
                            className={`text-md  ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData[0]?.report_detail
                                ?.recommendations[1]?.recommendation
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                      <div className="flex justify-between space-x-16 items-center pt-2 px-2">
                        <div className="flex justify-start space-x-2 items-center">
                          <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                            {" "}
                            3
                          </span>
                          <p
                            className={`text-md   ${themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                              }`}
                          >
                            {
                              currentSurveyInsightData[0]?.report_detail
                                ?.recommendations[2]?.recommendation
                            }
                          </p>
                        </div>
                        {/* <span
                          className={`text-md  font-bold ${
                            themeMode === "dark"
                              ? "text-[#FFFFFF]"
                              : "text-gray-800"
                          }`}
                        >
                          4.2
                        </span> */}
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full justify-end pr-4 pt-4">
                    <button
                      className={`  w-16 h-[25px] text-[14px] ${themeMode === "dark"
                        ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a] hover:text-[#fff] text-white-8"
                        : "border-[#1725471a] bg-[#BCBCBC] hover:bg-[#1725471a] hover:text-[#000] text-black-8"
                        }`}
                    // onClick={() => {
                    //   navigate("/surveys/" + currentSurvey.ID + "/recommendations");
                    // }}
                    >
                      DETAIL
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {totalAnswers.length > 0 && (
              <div
                className={`flex flex-0 w-auto 2xl:flex-1 w-auto text-start flex-col pr-4 pb-8`}
              >
                <HeatmapComponent
                  totalData={totalAnswers}
                  themeMode={themeMode}
                />
              </div>
            )}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:flex xl:flex-row 2xl:flex-col gap-2 w-[100%] ml-0 px-0 mx-0 2xl:w-[20%]">
            {currentSurveyInsightData[0]?.report_detail?.scores?.sections?.map(
              (section, index) => (
                <div key={index} className=" text-start  mt-4 flex flex-col">
                  <div
                    className={`shadow-md rounded-lg pt-2 px-0 pb-0 w-full min-w-[150px] h-[150px]  text-[20px]
                        ${themeMode === "dark"
                        ? "bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer "
                        : "bg-white text-gray-800 cursor-pointer"
                      }
                          
                        `}
                  >
                    <div className="p-4 py-1 rounded-lg space-y-8">
                      <div className="flex justify-between items-center mb-3">
                        <span
                          className={`size-5 w-full truncate text-sm sm:text-[16px] 3xl:[text-20px]  font-bold   ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                            }`}
                        >
                          {section.name.length > 20
                            ? section.name.slice(0, 20) + "..."
                            : section.name}
                        </span>
                      </div>
                      <div className="flex justify-between items-center mb-3">
                        <p className="text-sm sm:text-[48px] font-bold text-[#44A5E4] ">
                          {" "}
                          {getDisplayScore(section.score).toFixed(2)}
                        </p>
                      </div>
                      <div className="relative w-full bg-transparent h-[13px] ">
                        <div
                          className={`bg-custom-gradient h-[13px]`}
                          style={{ width: `${section.score * 20}%` }}
                        ></div>
                        <div
                          className={`absolute bg-[#596877] top-[0px] h-[13px] z-20`}
                          style={{
                            left: `${section.score * 20}%`,
                            width: `${100 - section.score * 20}%`,
                          }}
                        ></div>
                        <div
                          className={`absolute top-[-8px] h-[5rem] w-10 transform -translate-x-1/2 z-20 `}
                          style={{ left: `${section.score * 20}%` }}
                        >
                          <DownIcon className={`w-8 h-8 `} stroke="2" fill="#fff" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
    
      // :( surveyReportResults.filter(item => item.status !== "completed")
      //       .map(item => (
      //            <div
      //         ref={surveyCardRef}
      //         key={item.survey_id}
      //         id="cardBody"
      //         className={`shadow-md  rounded-lg pt-2 px-0 pb-0 w-[250px] sm:w-[300px] h-[200px]  flex justify-between flex-col ${themeMode === "dark"
      //             ? "bg-[#dedef00a] hover:bg-[#282834] text-white cursor-pointer hover:shadow-[0_0_1px_1px_#205DC2] hover:animate-[ease-in-out_1s]"
      //             : "bg-white text-gray-800 cursor-pointer hover:bg-gray-100 hover:shadow-[0_0_1px_1px_#205DC2]"
      //           }`}
      //       >
      //         <div className="p-1 py-1 rounded-lg sm:p-1 md:p-4 lg:p-4 xl:p-4 flex flex-grow flex-col">
      //           <div className="flex justify-between  items-center mb-3">
      //             {item.status === "Draft" && (
      //               <div className="flex items-center">
      //                 <svg
      //                   className="size-5 mt-1"
      //                   fill="#A1A1A1"
      //                   strokeWidth="1"
      //                   viewBox="0 0 24 24"
      //                   xmlns="http://www.w3.org/2000/svg"
      //                 >
      //                   <path
      //                     fillRule="evenodd"
      //                     clipRule="evenodd"
      //                     d="M6.97975 1.07389C3.92356 1.52014 1.50831 3.94118 1.0708 7.0002H2.08287C2.50337 4.49345 4.47822 2.51374 6.9825 2.08599L6.97975 1.07389ZM8.98249 2.08014L8.97974 1.06812C12.055 1.49885 14.4896 3.92773 14.9291 7.0002H13.917C13.4945 4.48183 11.5033 2.4954 8.98249 2.08014ZM9.01467 13.9146C11.5201 13.4879 13.4962 11.5077 13.917 9.00019H14.929C14.4913 12.06 12.0748 14.4815 9.01742 14.9267L9.01467 13.9146ZM2.0829 9.0002C2.50529 11.5176 4.49522 13.5034 7.01468 13.9196L7.01743 14.9317C3.94351 14.4999 1.51022 12.0717 1.07083 9.0002H2.0829Z"
      //                   ></path>
      //                 </svg>
      //                 <span className="size-5 whitespace-nowrap text-xs text-[#A1A1A1]">
      //                   {item.status}
      //                 </span>
      //               </div>
      //             )}
      //             {item.status.toLowerCase() === "running" && (
      //               <div className="flex items-center">
      //                 <svg
      //                   className="size-5 mt-1"
      //                   fill="#5195D7"
      //                   strokeWidth="1"
      //                   viewBox="0 0 24 24"
      //                   xmlns="http://www.w3.org/2000/svg"
      //                 >
      //                   <path
      //                     fillRule="evenodd"
      //                     clipRule="evenodd"
      //                     d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
      //                   ></path>
      //                   <path
      //                     d="M 4.5 4.5 L 9 4.5 A 4.5 4.5 0 1 1 0.00022499812500598182 4.54499925000375 Z"
      //                     transform="translate(3.5,3.5)"
      //                   ></path>
      //                 </svg>
      //                 <span className="size-5 whitespace-nowrap text-xs text-[#5195D7]">
      //                   {item.status
      //                     ? item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase()
      //                     : ""}

      //                 </span>
      //               </div>
      //             )}
      //           </div>
      //           <p
      //             className="text-sm font-semibold mb-4 line-clamp-1"
      //             title={item.survey_name}
      //           >
      //             {item.survey_name}
      //           </p>
      //           {/* <p className="text-[0.70rem] mb-1">
      //             <span>Created: </span>
      //             {fixDateFormat(item.started_at)}
      //           </p> */}
      //           <p className="text-[0.70rem] mb-1">{item.responded}</p>
      //         </div>
      //         <div
      //           className={`flex rounded-b-lg items-center justify-between  mt-auto  w-full ${themeMode === "dark" ? "bg-[#d9d9d912]" : "bg-[#2a2a2a12]"
      //             }`}
      //         >
      //           <ProgressBar value={item.progress} />
      //         </div>
      //       </div>
      //     )))
 ) }
    </div>
  );
}
